(function ($) {
	var $site = $('.site');
	var $reportMobileMenu = $('.js-report-mobile-menu');
	var $toggleReportMobileMenu = $('.js-toggle-report-mobile-menu');
	var $siteWrapper = $site.find('#main-content');
	var $document = $('html');
	var scrollTop;

	var unlockBody = function () {
		$document.css({
			height: '',
			overflow: '',
			position: ''
		});

		$site.css({
			top: ''
		});

		window.scrollTo(0, scrollTop);
		window.setTimeout(function () {
			scrollTop = null;
		}, 0);
	};

	var lockBody = function () {
		if (window.pageYOffset) {
			scrollTop = window.pageYOffset;
			$site.css({
				top: - (scrollTop + 50),
			});
		}

		$document.css({
			height: '100%',
			overflow: 'hidden',
			position: 'fixed'
		});
	};

	var addEventListenerToLastVisibleLink = function (e, link) {
		if (e.which === 9 && !e.shiftKey) {
			var lastVisibleLink = $reportMobileMenu.find('a:visible').last();
			if (link.is(lastVisibleLink)) {
				e.preventDefault();
				$reportMobileMenu.find('.js-toggle-report-mobile-menu').focus();
			} else {
				lastVisibleLink.keydown(function (e) {
					addEventListenerToLastVisibleLink(e, lastVisibleLink);
				});
			}
		}
	};

	var toggleReportMobileMenu = function () {
		$reportMobileMenu.toggleClass('report-mobile-menu--is-open');
		$toggleReportMobileMenu.toggleClass('report-mobile-menu__button--is-open');

		if ($('body').hasClass('prevent-scroll')) {
			unlockBody();
		} 
		else {
			lockBody();
		}

		$('body').toggleClass('prevent-scroll');

		if ($siteWrapper.hasAttr('tabindex')) {
			$siteWrapper.removeAttr('tabindex');
		}
		else {
			$siteWrapper.attr('tabindex', '-1');
		}

		//if open, lock tabindex and set focus on first element
		if ($reportMobileMenu.hasClass('report-mobile-menu--is-open')) {
			$reportMobileMenu.find('a').first().focus();

			//if tabbing on the last link, go to close button next
			$reportMobileMenu.find('a:visible').last().keydown(function (e) {
				addEventListenerToLastVisibleLink(e, $(this));
			});

			//if shift + tabbing on the close button, go to last menu link
			$reportMobileMenu.find('.report-mobile-menu-button--close').keydown(function(e) {
				if (e.shiftKey && e.keyCode === 9) {
					e.preventDefault();
					$reportMobileMenu.find('a:visible').last().focus();
				}
			});
		} else {
			$('.report-mobile-menu-button--open').first().focus();
		}
	};

	$toggleReportMobileMenu.on('click', toggleReportMobileMenu);
})(jQuery);
